import { z } from "zod";
import { machineWorkstationSchema } from "@packsize/schemas/machines";

import { PORT_MAX, PORT_MIN } from "./constants";
import { machineSchema } from "./machine";
import { machineSecurePrintConfiguration } from "./machine-secure-print-configuration";

export const cvpRangeMachineRequestSchema = z.object({
	alias: z.string(),
	description: z.string().optional(),
	ipOrDnsName: z.string().optional(),
	port: z.number().min(PORT_MIN).max(PORT_MAX).optional(),
	securePrintConfiguration: machineSecurePrintConfiguration.nullish(),
});

const cvpRangeSettingsTrack = z.object({
	installed: z.boolean(),
	materialBrand: z.string().optional(),
	materialWidth: z.number().optional(),
	materialThickness: z.number().optional(),
	isEmpty: z.boolean(),
});

const cvpRangePlcSettings = z.object({
	track1: cvpRangeSettingsTrack.optional(),
	track2: cvpRangeSettingsTrack.optional(),
	track3: cvpRangeSettingsTrack.optional(),
	track4: cvpRangeSettingsTrack.optional(),
});

export const cvpRangeMachineSchema = machineSchema.extend({
	plcSettings: cvpRangePlcSettings.optional(),
	securePrintConfiguration: machineSecurePrintConfiguration.nullish(),
	workstations: z.array(machineWorkstationSchema),
});

export type CvpRangeMachine = z.infer<typeof cvpRangeMachineSchema>;
export type CvpRangeMachineRequest = z.infer<typeof cvpRangeMachineRequestSchema>;
